import React from "react";
import styles from "./navbar.module.scss";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { GiHamburgerMenu } from "react-icons/gi";

const Navbar: React.FC = () => {
  const [state, setState] = React.useState(false);

  const toggleDrawer =
    (anchor: string, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState(!state);
    };

  return (
    <>
      <div className={styles.desktop}>
        <nav className={styles.navbar}>
          <button>
            <a href="https://www.zevi.ai/">Enquire now</a>
          </button>
        </nav>
      </div>
      <div className={styles.mobile}>
        <Button onClick={toggleDrawer("right", true)} sx={{ padding: 0, justifyContent: "right" }}>
          <GiHamburgerMenu className={styles.hamburgerIcon} />
        </Button>
        <Drawer
          anchor={"right"}
          open={state}
          onClose={toggleDrawer("right", false)}
          PaperProps={{
            sx: { width: "60%", paddingTop: "28px", paddingRight: "5%" },
          }}
        >
          <List>
            {["Enquire Now"].map((text) => (
              <ListItem key={text} disablePadding>
                <ListItemButton>
                  {text !== "Enquire Now" ? (
                    <ListItemText
                      primary={text}
                      sx={{ textAlign: "right" }}
                      primaryTypographyProps={{
                        sx: {
                          fontWeight: 700,
                          fontFamily: "Lato",
                          fontSize: "1.2rem",
                        },
                      }}
                    />
                  ) : (
                    <ListItemText
                      primary={text}
                      sx={{ textAlign: "right" }}
                      primaryTypographyProps={{
                        sx: {
                          fontWeight: 700,
                          fontFamily: "Lato",
                          padding: "14px 24px",
                          color: "#fff",
                          backgroundColor: "#8b7ce1",
                          borderRadius: "8px",
                          maxWidth: "200px",
                          marginLeft: "auto",
                          marginTop: "14px",
                          display: "flex",
                          justifyContent: "center",
                        },
                      }}
                    />
                  )}
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </div>
    </>
  );
};

export default Navbar;
